import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          돌아가기
        </Link>

        <h1 className="text-2xl font-bold mb-2">이용약관</h1>
        <p className="text-sm text-muted-foreground mb-10">최종 수정일: 2026년 4월 3일</p>

        <div className="space-y-10 text-sm leading-relaxed text-foreground/90">
          <Section title="제1조 (목적)">
            <p>
              본 약관은 스텝언(Stepeon, 이하 &quot;회사&quot;)이 제공하는 &quot;내 고객 신호등&quot;
              서비스(이하 &quot;서비스&quot;)의 이용 조건 및 절차, 회사와 이용자의 권리·의무를
              규정함을 목적으로 합니다.
            </p>
          </Section>

          <Section title="제2조 (서비스의 내용)">
            <p>회사는 카페24 쇼핑몰 운영자를 대상으로 다음의 서비스를 제공합니다.</p>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>RFM(Recency, Frequency, Monetary) 기반 고객 세그먼트 분석</li>
              <li>고객 생애가치(LTV) 예측 및 코호트 분석</li>
              <li>구매주기 분석 및 재구매 예측</li>
              <li>세그먼트별 자동 쿠폰 발급 (유료 요금제)</li>
            </ul>
          </Section>

          <Section title="제3조 (이용 계약의 성립)">
            <p>
              이용 계약은 카페24 앱스토어를 통해 본 앱을 설치하고, 카페24가 제공하는 권한 동의
              절차를 완료한 시점에 성립됩니다.
            </p>
          </Section>

          <Section title="제4조 (요금 및 결제)">
            <ul className="list-disc pl-5 space-y-1">
              <li>Free 요금제: 기본 RFM 분석 기능을 무료로 제공합니다.</li>
              <li>
                Pro / Business 요금제: 월 정기결제 방식이며, 카페24 결제 시스템을 통해 처리됩니다.
              </li>
              <li>요금제 변경 및 해지는 앱 내 &quot;플랜 및 결제&quot; 메뉴에서 가능합니다.</li>
              <li>결제 취소 및 환불은 카페24 앱스토어 정책에 따릅니다.</li>
            </ul>
          </Section>

          <Section title="제5조 (이용자의 의무)">
            <ul className="list-disc pl-5 space-y-1">
              <li>이용자는 서비스를 본래 목적에 맞게 사용하여야 합니다.</li>
              <li>
                이용자는 타인의 정보를 부정하게 사용하거나, 서비스의 정상적인 운영을 방해하는 행위를
                하여서는 안 됩니다.
              </li>
              <li>이용자는 관련 법령과 본 약관을 준수하여야 합니다.</li>
            </ul>
          </Section>

          <Section title="제6조 (서비스의 변경 및 중단)">
            <p>
              회사는 운영상 필요한 경우 서비스의 전부 또는 일부를 변경하거나 중단할 수 있으며, 이
              경우 사전에 공지합니다. 다만, 긴급한 사유가 있는 경우 사후에 공지할 수 있습니다.
            </p>
          </Section>

          <Section title="제7조 (면책)">
            <ul className="list-disc pl-5 space-y-1">
              <li>
                회사는 카페24 API의 장애, 데이터 지연 등 회사의 통제 범위 밖의 사유로 발생한 손해에
                대해 책임을 지지 않습니다.
              </li>
              <li>
                분석 결과는 참고용 정보이며, 이를 기반으로 한 경영 판단의 결과에 대해 회사는 책임을
                지지 않습니다.
              </li>
            </ul>
          </Section>

          <Section title="제8조 (계약 해지)">
            <p>
              이용자는 언제든지 카페24 앱스토어에서 앱을 삭제하여 이용 계약을 해지할 수 있습니다.
              해지 시 인증 토큰과 세션 정보는 즉시 파기되며, 주문 데이터 및 분석 결과는 재설치 시
              서비스 연속성을 위해 30일간 보유 후 파기됩니다. 즉시 삭제를 원하시는 경우 고객센터로
              요청하실 수 있습니다.
            </p>
          </Section>

          <Section title="제9조 (분쟁 해결)">
            <p>
              본 약관과 관련한 분쟁은 대한민국 법률에 따르며, 회사의 소재지를 관할하는 법원을 제1심
              관할 법원으로 합니다.
            </p>
          </Section>

          <Section title="제10조 (연락처)">
            <p>
              서비스 제공자: 스텝언(Stepeon)
              <br />
              이메일: ldu1020@stepeon.com
              <br />
              연락처: 010-4659-1944
            </p>
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section>
      <h2 className="text-base font-semibold mb-3">{title}</h2>
      {children}
    </section>
  );
}
